/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import cx from 'classnames';
import uniqid from 'uniqid';
import { CloudinaryPicture } from '@bwoty-web/ui-kit';
import RoomGallery from './roomGallery';
import ConceptInfo from '../views/hotelInfo/sections/accommodation/concept/conceptInfo';
import PartInfo from '../views/hotelInfo/sections/accommodation/concept/partInfo';
import SectionParagraph from './sectionParagraph';
import './roomType.scss';

const imageSizes = [
  {
    width: 460,
    height: 730,
    breakpoint: 768,
  },
  {
    width: 393,
    height: 624,
    breakpoint: 425,
  },
  {
    width: 333,
    height: 544,
    breakpoint: 375,
  },
];

const RoomType = ({
  isConceptHotel,
  accommodationSection,
  toggleRoomInfo,
  roomType,
  generalUspList,
  showPartInfoRoomList,
  inPopup,
  className,
}) => {
  if (!roomType) {
    return null;
  }

  const galleryImages = roomType?.imageVideoList
  const hasNoImage = galleryImages?.length < 1;

  return (
    <div className={cx('gw-room-type', className, {'gw-room-type--has-no-image': hasNoImage})}>
      <RoomGallery
        gallery={galleryImages}
        hasNoImage={hasNoImage}
        labels={accommodationSection?.labels}
        roomImageMissing={accommodationSection?.images?.[1]}
        inPopup={inPopup}
      />
      <div className="gw-room-type-left">
        <div className="gw-room-type-heading-container">
          <h2 className="gw-room-type-heading">{roomType?.name}</h2>
          {roomType?.part?.name && (
            <span className="gw-room-type-building">
              {roomType?.part?.name}
            </span>
          )}
        </div>
        {isConceptHotel ? (
          <div
            className="gw-room-type-description"
            dangerouslySetInnerHTML={{
              __html: roomType?.texts?.description || '',
            }}
          />
        ) : (
          roomType?.texts?.map((paragraph) => {
            return (
              <SectionParagraph
                key={uniqid('room-type-paragraph')}
                paragraph={paragraph}
              />
            );
          })
        )}
        {roomType?.roomPlan && (
          <div className="gw-room-type-floorplans">
            {roomType?.roomPlan?.map((picture) => (
              <div key={uniqid('room-floorplans-picture-')}>
                <CloudinaryPicture
                  img={{
                    cloudinaryUriTemplate: picture.cloudinaryUriTemplate,
                  }}
                  sizes={imageSizes}
                  retina
                />
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="gw-room-type-right">
        {isConceptHotel ? (
          <ConceptInfo concept={roomType?.concept} />
        ) : (
          <SectionParagraph
            key={uniqid('room-type-general-usp-list')}
            paragraph={generalUspList}
          />
        )}
      </div>
      {isConceptHotel && (
        <PartInfo
          roomType={roomType}
          texts={accommodationSection.labels}
          toggleRoomInfo={toggleRoomInfo}
          showPartInfoRoomList={showPartInfoRoomList}
        />
      )}
    </div>
  );
};

RoomType.propTypes = {
  isConceptHotel: PropTypes.bool.isRequired,
  showPartInfoRoomList: PropTypes.bool.isRequired,
  accommodationSection: PropTypes.shape({
    labels: PropTypes.shape(),
    images: PropTypes.arrayOf(
      PropTypes.shape({
        itemKey: PropTypes.string,
        media: PropTypes.shape({
          cloudinaryUriTemplate: PropTypes.string,
        }),
        alt: PropTypes.string,
      }),
    ),
  }),
  toggleRoomInfo: PropTypes.func,
  generalUspList: PropTypes.shape({}),
  roomType: PropTypes.shape({
    name: PropTypes.string,
    texts: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.shape({})),
      PropTypes.shape({
        description: PropTypes.string,
      }),
    ]),
    concept: PropTypes.shape({
      name: PropTypes.string,
    }),
    part: PropTypes.shape({
      name: PropTypes.string,
    }),
    imageVideoList: PropTypes.arrayOf(PropTypes.shape({})),
    roomPlan: PropTypes.arrayOf(
      PropTypes.shape({
        cloudinaryUriTemplate: PropTypes.string,
      }),
    ),
  }),
  inPopup: PropTypes.bool,
  className: PropTypes.string,
};

RoomType.defaultProps = {
  roomType: null,
  generalUspList: null,
  accommodationSection: {},
  toggleRoomInfo: () => { },
  inPopup: false,
  className: '',
};

export default RoomType;
